import { FC, ReactEventHandler, useRef } from 'react';
import { SvgIcon, Typography } from '@mui/material';

import { ReactComponent as IconWeChat } from 'src/assets/svg/wechat-logo.svg';

import { ContactUsButton } from './contact-us-button';

export const WechatButton: FC<{ onClick: ReactEventHandler }> = ({ onClick }) => {
    const Icon = useRef(
        <SvgIcon>
            <IconWeChat />
        </SvgIcon>
    );

    return (
        <ContactUsButton icon={Icon.current} onClick={onClick}>
            <Typography>WeChat</Typography>
        </ContactUsButton>
    );
};
